import matchSorter from 'match-sorter';
import { graphql } from 'gatsby';

const getProductVarieties = item =>
  (item.products || []).flatMap(({ grapeVarieties }) =>
    (grapeVarieties || []).map(({ varietyName }) => varietyName)
  );

export default function useSearch(items, query) {
  return matchSorter(items, query, {
    keys: [
      ({ shortName, vintage }) => `${shortName} ${vintage || ''}`,
      'producer.name',
      { key: 'vintage', threshold: matchSorter.rankings.EQUAL },
      'regionName',
      'classification',
      getProductVarieties,
    ],
    threshold: matchSorter.rankings.ACRONYM,
  });
}

export const fragment = graphql`
  fragment Search_Product on Product {
    __typename
    grapeVarieties {
      varietyName
    }
    regionName
    classification
    shortName
    vintage(removeNonVintage: true)
    producer {
      name
    }
  }
`;
